

export default function HorizontalImageCard({imageURL, imageALT, title, blurb}) {

    return (
        <div>
            <div
                className="card rounded-0 border-2 border-dark">
                <div className="media-wrapper">
                    <div>
                        <img loading="lazy"
                             src={imageURL}
                             width="420"
                             height="350"
                             alt={imageALT}
                             className="img-fluid"/>
                    </div>
                    {
                        Boolean(Boolean(title) || Boolean(blurb)) &&
                        <div
                            className="card-body pfs-4">
                            <h6>
                                <div>
                                    {title}
                                </div>
                            </h6>
                            <div>
                                <p>{blurb}</p>
                            </div>
                        </div>
                    }
                    <div
                        className="card-link d-flex justify-content-end">
                    </div>
                </div>
            </div>
        </div>
    )
}